import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { currentLocale } from '../state/locale.state';

// Reads the locale signal directly — injecting LanguageService here would pull
// TranslateService → TranslateHttpLoader → HttpClient back into this interceptor.
export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  // Only our API; ./i18n/*.json asset loads stay untouched.
  if (!req.url.startsWith(environment.api.baseUrl) || req.headers.has('Accept-Language')) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'Accept-Language': currentLocale() } }));
};
